import script from "./ChurchSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./ChurchSchedule.vue?vue&type=script&setup=true&lang=js"

import "./ChurchSchedule.vue?vue&type=style&index=0&id=394e8b24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394e8b24"]])

export default __exports__